<script lang="ts">
  /**
   * 「AtCoder で問題文を読む」（problem-format.md §5.3、security.md §4.5）。source.url は schema と段階 2 を通った値。
   * 念のため https://atcoder.jp/ で始まるものだけをリンクにする。外部サイトの印付き、新しいタブ。
   */
  interface Props {
    url: string;
    testid?: string;
  }

  let { url, testid = 'atcoder-link' }: Props = $props();

  const ok = $derived(url.startsWith('https://atcoder.jp/contests/'));
</script>

{#if ok}
  <a class="external" href={url} target="_blank" rel="noopener noreferrer" data-testid={testid}
    >AtCoder で問題文を読む<span class="ext-mark" aria-hidden="true">↗</span><span
      class="visually-hidden">（外部サイト、新しいタブ）</span
    ></a
  >
{/if}

<style>
  .ext-mark {
    margin-left: 0.15em;
    font-size: 0.85em;
  }
</style>
